// URLのパラメータを取得
const params = location.href;
function getParams(params) {
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  const params_obj = {};
  let match;
  while ((match = regex.exec(params))) {
    params_obj[match[1]] = match[2];
  }
  return params_obj;
}
var params_hash = getParams(params);
var snap_id = params_hash['id'] - 9000;

// グローバル関数として定義
window.renderSnapProducts = function (data) {
  const snap = data.snap;
  const snap_images = data.snap_images || [];
  const staff = data.staff;
  const products = data.products || [];
  const related_snaps_map = data.related_snaps || {};

  if (!snap) {
    console.error('Snap data not found in renderSnapProducts');
    return;
  }

  // --- 1. Staff Section ---
  if (staff) {
    const new_staff_info_content = `
            <p>${staff.title}｜${staff.height}cm<br>普段の着用サイズ：トップス${staff.tops_size}｜ボトムス${staff.bottoms_size}</p>
        `;
    const profileContent = document.querySelector('.snap-product-profile-content');
    if (profileContent) {
      profileContent.innerHTML = new_staff_info_content;
    }
  }

  // --- 2. Products Section ---
  let new_styling_item_content = '';
  for (let i = 0; i < 6; i++) {
    const product = products[i];
    if (!product) {
      const sectionOtherProducts = document.getElementById('other_product_id_' + (i + 1));
      if (sectionOtherProducts) {
        sectionOtherProducts.remove();
      }
    } else {
      // Render related snaps (product_snap_section replacement)
      const relatedSnaps = related_snaps_map[product.handle] || [];
      renderRelatedSnaps(snap_id, product, i + 1, product.handle, product.product_name, relatedSnaps);

      new_styling_item_content += `
                <div class="blog-post-card group snap-center" style="opacity: 1; transform: translateY(0px);">
                    <a href="https://store.soeju.com/products/${product.handle}?variant=${product.variant_id}" class="overflow-hidden">
                    <img src="${product.src
        }" width="1040" height="1040" loading="lazy" sizes="(max-width: 699px) 95vw, (max-width: 1149px) calc(100vw / 2), calc((80rem - (5rem * (3 - 1) / 3)" class="blog-post-card__image w-full zoom-image group-hover:zoom">
                    </a>
                    <div class="blog-post-card__info">
                    <a href="https://store.soeju.com/products/${product.handle}?variant=${product.variant_id}">
                        <h2 class="blog-post-card__title snap-product-title">${product.product_name}</h2>
                        <span class="snap-product-info Text--subdued">¥${Number(product.price).toLocaleString()}<br>サイズ：${product.size}<br>カラー：${product.color}</span>
                    </a>
                    </div>
                </div>`;
    }
  }
  const stylingContainer = document.getElementById('new_styling_item_content_id');
  if (stylingContainer) {
    stylingContainer.innerHTML = new_styling_item_content;
  }

  // --- 3. Snap Comment & Date ---
  const snap_date = snap.created_at.slice(0, 10);
  const new_snap_comment_content = `
      <p>${snap.comment}</p>
      <div style="text-align:right;color:#aaa;">${snap_date}</div>`;
  const commentContentBoxes = document.querySelectorAll('.snap-product-comment-content');
  if (commentContentBoxes) {
    commentContentBoxes.forEach((commentContent) => (commentContent.innerHTML = new_snap_comment_content));
  }

  // --- 4. Main Snap Images ---
  // Note: This logic might conflict with c_snap-detail.liquid if they target same elements. 
  // Assuming c_snap-products.js targets elements specific to 'Other Styling' section or GemPages/Legacy areas.
  const imagesToDisplay = snap_images.length > 0 ? snap_images : (snap.top_img_url ? [{ img_url: snap.top_img_url }] : []);

  if (imagesToDisplay.length === 1) {
    // Single Image
    let new_snap_img_content = `<img src="${imagesToDisplay[0].img_url}">`;
    const imageContainer = document.querySelector('.main-snap-product__images');
    if (imageContainer) {
      imageContainer.innerHTML = new_snap_img_content;
      const carouselButtons = document.querySelectorAll('.flickity-prev-next-button');
      if (carouselButtons) carouselButtons.forEach((element) => element.remove());
      const carouselNav = document.querySelector('.product-gallery__thumbnail-scroller');
      if (carouselNav) carouselNav.remove();
    }
  } else {
    // Multiple Images
    for (let i = 1; i < 11; i++) {
      const snap_image = imagesToDisplay[i - 1]; // 0-indexed
      const imgUrl = snap_image ? (snap_image.img_url || snap_image.top_img_url) : null;

      if (imgUrl) {
        let new_snap_img_content = `<img src="${imgUrl}">`;
        const carouselCell = document.getElementById('snap-carousel' + i);
        if (carouselCell) carouselCell.innerHTML = new_snap_img_content;
        const carouselCellNav = document.getElementById('snap-carousel-nav' + i);
        if (carouselCellNav) carouselCellNav.innerHTML = new_snap_img_content;
      } else {
        const carouselCell = document.getElementById('snap-carousel' + i);
        if (carouselCell) {
          carouselCell.style.display = 'none';
          carouselCell.style.visibility = 'hidden';
          carouselCell.remove();
        }
        const carouselCellNav = document.getElementById('snap-carousel-nav' + i);
        if (carouselCellNav) {
          carouselCellNav.style.display = 'none';
          carouselCellNav.style.visibility = 'hidden';
          carouselCellNav.remove();
        }
      }
    }
  }
};

// Check if data is already available globally (from c_snap-detail.liquid)
if (window.snapPageCompleteData) {
  window.renderSnapProducts(window.snapPageCompleteData);
}

// Helper function for Related Snaps (replaces product_snap_section fetch logic)
function renderRelatedSnaps(snap_id, product, product_num, handle, product_name, snaps) {
  let new_other_product_content = `
        <span>
            <a href="https://store.soeju.com/products/${handle}">${product.product_name}</a>
        </span>を使ったその他STYLING
    `;

  var otherProductTitleId = document.getElementById('other_product_title_id_' + product_num);
  if (otherProductTitleId) {
    otherProductTitleId.innerHTML = new_other_product_content;
  }

  let product_snap_num = 0;
  // Iterate up to 10
  for (let i = 0; i < 10; i++) {
    const snap = snaps[i]; // 0-indexed from array
    product_snap_num += 1;

    if (!snap) {
      const productSnap = document.getElementById('product-snap-' + product_num + '-' + product_snap_num);
      if (productSnap) {
        productSnap.remove();
      }
    } else {
      const size_text = extractSizeFromProductIds(snap.product_ids, product.model_number);

      let new_other_product_snap_content = `
              <div class="blog-post-card group snap-center" style="opacity: 1; transform: translateY(0px);">
                <a href="https://store.soeju.com/pages/snap?id=${9000 + snap.id}" class="overflow-hidden">
                <img src="${snap.top_img_url
        }" width="1040" height="1040" loading="lazy" sizes="(max-width: 699px) 95vw, (max-width: 1149px) calc(100vw / 2), calc((80rem - (5rem * (3 - 1) / 3)" class="blog-post-card__image w-full zoom-image group-hover:zoom">
                </a>
                <div class="blog-post-card__info">
                <p class="blog-post-card__title h4">${snap.height}cm ${size_text}</p>
                </div>
            </div>`;

      const productSnap = document.getElementById('product-snap-' + product_num + '-' + product_snap_num);
      if (productSnap) {
        productSnap.innerHTML = new_other_product_snap_content;
      }
    }
  }

  if (snaps.length == 0) {
    const otherProductId = document.getElementById('other_product_id_' + product_num);
    if (otherProductId) {
      otherProductId.style.display = 'none';
      otherProductId.style.visibility = 'hidden';
      otherProductId.remove();
    }
  }
}

/**
 * 商品IDからサイズ抽出 (unchanged logic)
 */
function extractSizeFromProductIds(productIds, targetModelNumber) {
  if (!productIds || !targetModelNumber) return '';

  const values = productIds.split(',');
  const matchedValue = values.find((value) => value.includes(targetModelNumber));
  const extractedSize = matchedValue ? matchedValue.split('-').pop() : null;

  if (!extractedSize) return '';

  // 特殊処理: ロングシャツワンピース
  if (targetModelNumber === 'S-01-OP-025') {
    const sizeMap = { M: 'FREE', L: 'TALL', T: 'TALL' };
    return `/ ${sizeMap[extractedSize] || extractedSize}`;
  }

  return `/ ${extractedSize}`;
}
